/* eslint-disable camelcase */
window.startNoInterrupt = function startNoInterrupt() {
  window.merchantos.interrupt.block();
};

window.isNoInterrupt = function isNoInterrupt() {
  if (!window.merchantos.interrupt.isBlocked()) return false;

  if (window.merchantos.interrupt.getTime() < 20000) return true;
  window.merchantos.interrupt.free();

  return false;
};

window.stopNoInterrupt = function stopNoInterrupt() {
  if (!window) return;

  window.merchantos.interrupt.free();
};

window.setWorking = function setWorking(panel) {
  if (!panel) return;

  let name = 'view_listing';

  // eslint-disable-next-line eqeqeq
  if (panel.id != 'view' && panel.id != 'listing') {
    name = panel.id;
  }

  window.merchantos.interrupt.block(name);
};

window.isWorking = function isWorking(panel) {
  if (window.isNoInterrupt()) {
    return true;
  }

  if (!panel) {
    return false;
  }

  let name = 'view_listing';

  // eslint-disable-next-line eqeqeq
  if (panel.id != 'view' && panel.id != 'listing') {
    name = panel.id;
  }

  if (!window.merchantos.interrupt.isBlocked(name)) {
    return false;
  }

  const time_since_start = window.merchantos.interrupt.getTime(name);
  if (time_since_start > 20000) {
    window.merchantos.interrupt.free(name);
    return false;
  }

  return true;
};

window.clearWorking = function clearWorking(pannel) {
  if (!pannel) return;

  let name = 'view_listing';

  if (pannel.id !== 'view' && pannel.id !== 'listing') {
    name = pannel.id;
  }

  window.merchantos.interrupt.free(name);
};

class InterruptQueue implements MerchantosInterruptQueue {
  list: (() => void)[];

  name: string;

  working: number;

  constructor(name: string) {
    this.name = name;
    this.list = [];
    this.working = 0;
  }

  push = (fnc: () => void) => this.list.push(fnc);

  process = () => {
    this.free();
    if (this.list.length <= 0) {
      return false;
    }
    const fnc = this.list.shift();
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    fnc();
    return true;
  };

  remove = () => this.list.shift();

  // eslint-disable-next-line no-return-assign
  empty = () => (this.list = []);

  // eslint-disable-next-line no-return-assign
  block = () => (this.working = new Date().getTime());

  isBlocked = () => {
    if (this.working > 0) {
      return true;
    }
    return false;
  };

  getTime = () => new Date().getTime() - this.working;

  // eslint-disable-next-line no-return-assign
  free = () => (this.working = 0);
}

class Interrupt implements MerchantosInterrupt {
  list: { [key: string]: MerchantosInterruptQueue };

  working: number;

  queue: MerchantosInterruptQueueConstructor;

  constructor() {
    this.list = {};
    this.working = 0;
    this.queue = InterruptQueue;
  }

  getQueue = (name: string) => {
    if (this.list[name]) return this.list[name];
    // eslint-disable-next-line new-cap
    this.list[name] = new this.queue(name);
    return this.list[name];
  };

  push = (name: string, fnc: () => void) => {
    const q = this.getQueue(name);
    q.push(fnc);
  };

  process = (name: string) => {
    if (!this.list[name]) return false;
    const q = this.getQueue(name);
    return q.process();
  };

  // @ts-expect-error ts-migrate(2416) FIXME: Property 'isBlocked' in type 'Interrupt' is not as... Remove this comment to see the full error message
  isBlocked = (name: string) => {
    if (!name) {
      if (this.working > 0) {
        return true;
      }
      return false;
    }
    const q = this.getQueue(name);
    return q.isBlocked();
  };

  // @ts-expect-error ts-migrate(2416) FIXME: Property 'block' in type 'Interrupt' is not assign... Remove this comment to see the full error message
  block = (name: string) => {
    if (!name) {
      this.working = new Date().getTime();
      return;
    }
    const q = this.getQueue(name);
    q.block();
  };

  // @ts-expect-error ts-migrate(2416) FIXME: Property 'getTime' in type 'Interrupt' is not assi... Remove this comment to see the full error message
  getTime = (name: string) => {
    if (!name) {
      return new Date().getTime() - this.working;
    }
    const q = this.getQueue(name);
    return q.getTime();
  };

  // @ts-expect-error ts-migrate(2416) FIXME: Property 'free' in type 'Interrupt' is not assigna... Remove this comment to see the full error message
  free = (name: string) => {
    if (!name) {
      this.working = 0;
      return;
    }
    const q = this.getQueue(name);
    q.free();
  };

  empty = (name: string) => {
    const q = this.getQueue(name);
    q.empty();
  };
}

// @ts-expect-error ts-migrate(2322) FIXME: Type 'Interrupt' is not assignable to type 'Mercha... Remove this comment to see the full error message
window.merchantos.interrupt = new Interrupt();
